export default __webpack_public_path__ + "static/media/thumb-placeholder.294a69f4.png";